const domain = 'https://luckypm-api.wiltechs.com';

export default {
    domain,
    baseUrl: domain + '/api',
    signalRUrl: domain + '/luckyPM_hub',
    authUrl: 'https://passtest.wiltechs.com/Token',
    authCode: 'Basic NDUwYzZjMDNmYzQ0YzQzYjo3OWQ5MDJkYmZlM2Q3ODFm',
};
